var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_5994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4.79113 8 5.56449 7.76541 6.22228 7.32588C6.88008 6.88635 7.39277 6.26164 7.69552 5.53074C7.99827 4.79983 8.07748 3.99556 7.92314 3.21964C7.7688 2.44372 7.38784 1.73098 6.82843 1.17157C6.26902 0.612165 5.55629 0.231202 4.78036 0.0768607C4.00444 -0.0774802 3.20017 0.00173314 2.46927 0.304484C1.73836 0.607234 1.11365 1.11992 0.674122 1.77772C0.234596 2.43552 0 3.20888 0 4C0.00114703 5.06052 0.422943 6.07727 1.17284 6.82716C1.92274 7.57706 2.93949 7.99886 4 8ZM4 1.66667C4.09889 1.66667 4.19556 1.69599 4.27779 1.75093C4.36001 1.80587 4.4241 1.88396 4.46194 1.97533C4.49978 2.06669 4.50969 2.16722 4.49039 2.26421C4.4711 2.3612 4.42348 2.4503 4.35355 2.52022C4.28363 2.59015 4.19454 2.63777 4.09755 2.65706C4.00056 2.67635 3.90002 2.66645 3.80866 2.62861C3.7173 2.59076 3.63921 2.52668 3.58427 2.44445C3.52932 2.36223 3.5 2.26556 3.5 2.16667C3.5 2.03406 3.55268 1.90688 3.64645 1.81312C3.74022 1.71935 3.86739 1.66667 4 1.66667ZM3.66667 3.33334H4C4.17681 3.33334 4.34638 3.40357 4.47141 3.5286C4.59643 3.65362 4.66667 3.82319 4.66667 4V6C4.66667 6.08841 4.63155 6.17319 4.56904 6.2357C4.50652 6.29822 4.42174 6.33334 4.33333 6.33334C4.24493 6.33334 4.16014 6.29822 4.09763 6.2357C4.03512 6.17319 4 6.08841 4 6V4H3.66667C3.57826 4 3.49348 3.96488 3.43096 3.90237C3.36845 3.83986 3.33333 3.75507 3.33333 3.66667C3.33333 3.57826 3.36845 3.49348 3.43096 3.43097C3.49348 3.36845 3.57826 3.33334 3.66667 3.33334Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_5994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationLogo);
export default __webpack_public_path__ + "static/media/informationLogo.1875f92ec2541dae7d95802e65ad6c47.svg";
export { ForwardRef as ReactComponent };